import { Link } from "react-router-dom";
import { hotRankings } from "@/mocks/hotNews";
import RankingRow from "@/components/feature/RankingRow";

export default function HomeRanking() {
  const rows = hotRankings.slice(0, 10);
  return (
    <section className="bg-background-100/70 py-10 md:py-14">
      <div className="container-x">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <div className="flex items-end justify-between gap-4">
              <div>
                <span className="chip bg-primary-500 text-background-50 px-3 py-1 text-xs font-bold">
                  <i className="ri-fire-fill"></i> 今日热瓜实时榜单
                </span>
                <h2 className="mt-3 font-heading text-2xl md:text-3xl">此刻全网在聊的 TOP 10</h2>
              </div>
              <span className="chip bg-background-50 text-primary-600 px-3 py-1 text-xs font-medium">
                <i className="ri-refresh-line"></i> 每 5 分钟更新
              </span>
            </div>
            <p className="mt-3 max-w-2xl text-sm text-foreground-600">
              综合搜索量、讨论速度与转发趋势实时生成。点进标题即可阅读完整进展，榜单变化随热点实时刷新。
            </p>

            <div className="card-surface mt-6 divide-y divide-background-200/70 px-2 py-1 sm:px-3">
              {rows.map((r) => (
                <RankingRow key={r.item.slug} item={r.item} rank={r.rank} />
              ))}
            </div>
            <Link to="/ranking" className="mt-5 inline-flex items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600">
              查看完整热榜 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <aside className="lg:col-span-4">
            <div className="rounded-2xl bg-gradient-to-br from-accent-500 to-secondary-500 p-5 text-background-50">
              <h3 className="font-heading text-xl">吃瓜小贴士</h3>
              <p className="mt-2 text-sm text-background-100/90">看热闹也要有分寸，先看权威信源，再等官方回应，理性吃瓜不上头。</p>
              <ul className="mt-4 space-y-2.5 text-sm">
                {["不传未经证实的谣言", "让瓜再飞一会儿", "理性讨论，友善发言"].map((t) => (
                  <li key={t} className="flex items-center gap-2 text-background-100">
                    <i className="ri-checkbox-circle-line text-primary-950"></i>
                    {t}
                  </li>
                ))}
              </ul>
              <Link to="/about" className="mt-4 inline-flex items-center gap-1 text-sm font-bold text-primary-950 hover:underline">
                了解我们 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}